module.exports = __webpack_public_path__ + "static/media/full_logo.c2f435ac.webp";